export const SERVICE_CONTENT_RESTRICTED_WRITE_SCOPE = 'service-content-restricted-write';
export const SERVICE_KNOWLEDGE_ARTICLE_WRITE_SCOPE = 'service-knowledge-article-write';
export const SERVICE_KNOWLEDGE_ARTICLE_PUBLISH_SCOPE = 'service-knowledge-article-publish';
export const KNOWLEDGE_BASE_PRIVATE_CONTENT_MANAGE_SCOPE = 'knowledge-base-private-content-manage';
export const DEEP_LINK_QUERIES = {
  ACCESS_CONTROL: 'audienceAccess',
  CATEGORIES: {
    CATEGORY: 'categories.category',
    SUBCATEGORY: 'categories.subcategory'
  },
  GENERAL: {
    TITLE: 'general.title',
    SLUG: 'general.slug',
    LANG: 'general.lang'
  },
  METADATA: {
    META_DESCRIPTION: 'metadata.metaDescription',
    TAGS: 'metadata.tags'
  }
};